import gql from 'graphql-tag';

export const MarkItemAsBoughtMutation = gql`
  mutation TrackerShoppingListMarkItemAsBought($input: DailyTrackerShoppingListMarkItemInputType!) {
    dailyTracker {
      shoppingListMarkItemAsBought(input: $input) {
        __typename
        ... on DailyTrackerShoppingListMarkItemSuccess {
          isBought
        }
        ... on Error {
          errorCode: code
          name
          description
        }
        ... on UnauthorizedException {
          authCode: code
        }
      }
    }
  }
`;

export const MarkItemAsNotBoughtMutation = gql`
  mutation TrackerShoppingListMarkItemAsNotBought(
    $input: DailyTrackerShoppingListMarkItemInputType!
  ) {
    dailyTracker {
      shoppingListMarkItemAsNotBought(input: $input) {
        __typename
        ... on DailyTrackerShoppingListMarkItemSuccess {
          isBought
        }
        ... on Error {
          errorCode: code
          name
          description
        }
        ... on UnauthorizedException {
          authCode: code
        }
      }
    }
  }
`;
